import React from "react";
import useEntity from "../../../hooks/useProviderUser";
import {
    Box, 
    Paper, 
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Link,
    TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from '@mui/utils';
import { CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {ID} from "../../../../types/global.d";
import EntityListHeader from "./ProviderUserListHeader";
import EntityListSearch from "./ProviderUserListSearch";
import {useLocation} from "react-router";
import ProviderUserListPagination from "./ProviderUserListPagination";
import * as Api from "../../../apis/ProviderUser.api";
import { ProviderUser } from "../../../types/models/ProviderUser";
import { PrimaryProviderUser } from "../../../types/models/ProviderUser";
import { usePagination } from '../../../../share';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate.ts";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import ProviderLink from "../../../../timber/components/provider/ProviderDetail/ProviderLink";
import ProviderName from "../../../../timber/components/provider/ProviderDetail/ProviderName";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import { PrimaryProvider } from "../../../../timber/types/models/Provider";
import { PrimaryUser } from "../../../../auth/types/models/User";
import {useTheme} from "@mui/material/styles";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import ProviderUserListItemTools from "./ProviderUserListItemTools";
import {useStateSession} from "../../../../hooks/useAuth";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

import useMediaQuery from '@mui/material/useMediaQuery';
import { Trans } from "@lingui/react/macro";
import {
    mdiLinkVariant,
} from "@mdi/js";
import {
    StyledFillNavLink,
    ToolbarTableCell,
    BigTableRow,
    BigTableHeaderRow,
    SmallTableRow,
    SmallTableHeaderRow,
    StyledTableCell,
    StyledMdiIcon,
} from "../../../../share/components/styled/Table";
import {OrderBy, OrderDirection} from "../../../../types/global.d";

type IProps = {
    showAdd: boolean,
    email?: string,
    name?: string,
    providerId?: ID,
    userId?: ID,
    };

const ProviderUserListItem = (props: IProps) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    
    const session = useStateSession()
    const {showAdd, ...query} = props;

    const { page, pageSize, handleChangePage, handleChangePageSize } = usePagination('ProviderUser')

    
    
    
    
    const [, setSearchInputValue, searchInputTerm] = useSearchDebounce();
    

    const [orderBys, setOrderBys] = React.useState<OrderBy[]>([]);

    const toggleOrder = React.useCallback((name: string) => {
        setOrderBys(prev => {
            const current = prev.find(item => item.name === name)
            return [
                {
                    name,
                    direction: current?.direction === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc
                },
                ...(prev.filter(item => item.name !== name))
            ]
        });
    }, []);

    const { data: dataSimple = {
        items: [],
        totalItems: 0,
        page,
        pageSize,
        numPages: 0
    }, 
        isLoading: isLoadingSimple,
        isFetching: isFetchingSimple,
        refetch: refetchSimple,
    } =
          Api.useGetProviderUserPresentationQuery({
                  list: { page, pageSize },
                  filter: {
                    providerIdRefs: (PrimaryProvider.fromQuery(query.providerId)) ? [ PrimaryProvider.fromQuery(query.providerId) ] : [],
                    userIdRefs: (PrimaryUser.fromQuery(query.userId)) ? [ PrimaryUser.fromQuery(query.userId) ] : [],
                    email: searchInputTerm || '',
                    emailOr: true,
                    name: searchInputTerm || '',
                    nameOr: true,
                    orderBys,
                  },
              })
    
    const {data, isLoading, isFetching, refetch} =
        {
                data: dataSimple,
                isLoading: isLoadingSimple,
                isFetching: isFetchingSimple,
                refetch: refetchSimple,
            }

    const routeLocation = useLocation();
    
    const onClickUrl = (entity: ProviderUser) => routeLocation.pathname.endsWith('provider-users') ?
        `${PrimaryProviderUser.fromEntity(entity).toPath()}`
        :
        `provider-users/${PrimaryProviderUser.fromEntity(entity).toPath()}`

    const onEditUrl = (entity: ProviderUser) => `${onClickUrl(entity)}/edit`

    
    
    return React.useMemo(() => (
        <Box>
            <Paper>
                <EntityListHeader showAdd={showAdd} {...query}/>
                <EntityListSearch
                    setSearchInputValue={setSearchInputValue}
                    
                    query={query}
                    refetch={refetch}
                />
                <TableContainer>

                    

                    

                    

                    

                    
        
                    
                    {isSmallScreen ?
                        <Table stickyHeader data-testid="ProviderUser-entity-list" size="small">
                            <TableHead>
                                <SmallTableHeaderRow>
                                    
                                    

                                    
                            <StyledTableCell align="left">
                                
                                <TableSortLabel
                                    active={ orderBys.find((item) => item.name === 'name') }
                                    direction={ orderBys.find((item) => item.name === 'name')?.direction || 'asc' }
                                    onClick={() => toggleOrder('name')}
                                >
                                
                                    <Trans>Name</Trans>
                                
                                </TableSortLabel>
                                
                            </StyledTableCell>
                        
                    
                                    
                                    
                            <StyledTableCell align="center">
                                
                                <TableSortLabel
                                    active={ orderBys.find((item) => item.name === 'userType') }
                                    direction={ orderBys.find((item) => item.name === 'userType')?.direction || 'asc' }
                                    onClick={() => toggleOrder('userType')}
                                >
                                
                                    <Trans>User Type</Trans>
                                
                                </TableSortLabel>
                                
                            </StyledTableCell>
                        
                    
                                    
                                    
                                </SmallTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <SmallTableRow
                                        hover={true}
                                        key={ PrimaryProviderUser.fromEntity(item).toPath() }
                                    >
                                        
                        
                        
                        

                        <TableCell
                            scope="row"
                            align="left"
                        >
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                                <Typography component="div" sx={ { fontWeight: 'bold', } }>
                                    { item.name ?
                                        <>
                                            
                        
                        { item.name || '-' }
                        
                    
                                        </>
                                        :
                                        '-'
                                    }
                                </Typography>
                                
                            
                            </Link>
                        </TableCell>

                    
                        
                    
                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { toStringUserType(item.userType) || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                        
                    
                        
                    
                                    </SmallTableRow>
                                ))}
                            </TableBody>
                        </Table>
                        :
                    
                        <Table stickyHeader data-testid="ProviderUser-entity-list" size="small">
                            <TableHead>
                                <BigTableHeaderRow>
                                    
                                    
                                    
                                    <StyledTableCell align="left">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'email') }
                                            direction={ orderBys.find((item) => item.name === 'email')?.direction || 'asc' }
                                            onClick={() => toggleOrder('email')}
                                        >
                                        
                                            <Trans>Email</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="left">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'name') }
                                            direction={ orderBys.find((item) => item.name === 'name')?.direction || 'asc' }
                                            onClick={() => toggleOrder('name')}
                                        >
                                        
                                            <Trans>Name</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="center">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'userType') }
                                            direction={ orderBys.find((item) => item.name === 'userType')?.direction || 'asc' }
                                            onClick={() => toggleOrder('userType')}
                                        >
                                        
                                            <Trans>User Type</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                </BigTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <BigTableRow
                                        hover={true}
                                        key={ PrimaryProviderUser.fromEntity(item).toPath() }
                                    >
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.email || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.name || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { toStringUserType(item.userType) || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        <ToolbarTableCell align="center" width="15%">
                                            <ProviderUserListItemTools data={ item }
                                                                               onClickUrl={onClickUrl(item)} onEditUrl={onEditUrl(item)}
                                                                                />
                                        </ToolbarTableCell>
                                    </BigTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    }
                    
            
                    { !data.totalItems && !isLoading && !isFetching &&
                        <Typography
                            sx={ { flex: '1 1 100%', padding: "2em", } }
                            component="div"
                        >
                            <Trans>No Provider Users</Trans>
                        </Typography>
                    }
                    { (isLoading || isFetching) &&
                        <GradientCircularProgress/>
                    }
                </TableContainer>
                <ProviderUserListPagination
                    totalItems={ data.totalItems }
                    page={Number(page)}
                    pageSize={pageSize}
                    handleChangePage={handleChangePage}
                    handleChangePageSize={handleChangePageSize}
                />
            </Paper>
        </Box>
    ), [isLoading, isFetching,isSmallScreen, data, page, pageSize, onClickUrl,  onEditUrl])
}

export default ProviderUserListItem;
